// extracted by mini-css-extract-plugin
export default {"Title":"classes_Title__WAzXi","Body":"classes_Body__x5INi","Img":"classes_Img__e7LLR"};